<template>
  <v-navigation-drawer
    v-model="dataFlag"
    :clipped="$vuetify.breakpoint.lgAndUp"
    :width="500"
    fixed
    right
    @input="setFlag"
  >
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>Update Company State</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closeDrawer" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row align-center justify-center>
      <v-col md="12">
        <div>
          <v-card-text>
            <v-select
              :items="productOptions"
              v-model="currentState"
              item-value="id"
              item-text="name"
              label="Company States"
              filled
            ></v-select>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    <v-footer absolute height="60">
      <v-flex px-4 py-4 text-right>
        <div>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="updateCompanyState"
            >Update State</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import companyAPI from '@/api/company.js';
export default {
  name: 'userStateDrawer',
  components: {},
  props: {
    userStateDrawer: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dataFlag: false,
      items: [],
      productOptions: [
        {
          id: 1,
          name: 'Free Trial',
        },
        {
          id: 2,
          name: 'Free Trial Expired',
        },
        {
          id: 3,
          name: 'Active Membership',
        },
        {
          id: 4,
          name: 'Suspended Membership',
        },
        {
          id: 5,
          name: 'Free Trial Extended',
        },
      ],
      loading: false,
      currentState: 1
    };
  },
  methods: {
    setFlag() {
      EventBus.$emit('USERSTATE_DRAWER_STATE', this.dataFlag);
    },
    closeDrawer() {
      EventBus.$emit('USERSTATE_DRAWER_STATE', false);
    },
    updateCompanyState() {
      console.log(this.currentState)
      this.loading = true;
      companyAPI
        .updateCompanyState(this.$route.params.id, '' , this.currentState )
        .then(() => {
          this.loading = false;
          EventBus.$emit('USER_STATE_UPDATED', true); 
          this.closeDrawer();
        });
    },
  },
  watch: {
    userStateDrawer: {
      handler(value) {
        this.dataFlag = value;
      },
      deep: true,
    },
    state:{
      handler(value) {
        this.currentState = value;
      },
      deep: true,
    }
  },
};
</script>
<style scoped>
.v-navigation-drawer {
  min-height: 400px !important;
}
</style>
